import { ContentResponseDtoAccessTypeEnum } from '@subflow/api-client';

export const accessTypesById: Record<
  string,
  {
    title: string;
    description: string;
    value: ContentResponseDtoAccessTypeEnum;
  }
> = {
  public: {
    value: ContentResponseDtoAccessTypeEnum.Public,
    title: 'Public',
    description: 'Anyone on the internet can access with a link',
  },
  restricted: {
    value: ContentResponseDtoAccessTypeEnum.Restricted,
    title: 'Restricted',
    description: 'Only subscribers can access content',
  },
};

export const accessTypes = Object.values(accessTypesById);
